import React, { useState, useCallback, useEffect, useMemo } from 'react'
import { compose } from 'recompose'
import { withHooks } from '../../../../../enhancers'
import { FastField } from 'formik'
import {
  Input,
  Select,
  Params,
} from '../../../../../components/formikComponent'
import { get } from 'lodash'

const DetailComponent = props => (
  <div className="d-flex m-b-10">
    <div className="w-50 d-flex align-items-center">
      <FastField
        name={`${props.name}.type`}
        component={Input}
        className="form-control"
        hidden
      />
      {props.label}
    </div>

    <div className="w-25 m-l-20 d-flex align-items-center">
      <FastField
        name={`${props.name}.formula`}
        component={Select}
        options={props.options}
        onChange={props.onChangeFormula}
        readOnly={props.isEdit}
        width="100%"
        isClearable={false}
      />
    </div>

    <div className="w-25 m-l-20">
      <Params
        configs={props.paramConfigs}
        name={props.name}
        whatBenefit={props.whatBenefit}
        isEdit={props.isEdit}
      />
    </div>
  </div>
)

const enhancer = compose(
  withHooks(props => {
    const [loading, setLoading] = useState(false)
    const [formula, setFormula] = useState('')

    useEffect(() => {
      setFormula(props.initialValueFormula)
    }, [props.initialValueFormula])

    const onChangeFormula = useCallback(e => {
      props.setFieldValue(`${props.name}.formula`, e.value)
      setFormula(e.value)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const paramConfigs = useMemo(() => {
      const options =
        props.options[
          props.options.findIndex(x => x.value === props.values.formula)
        ]

      return get(options, 'params', [])
    }, [props.values, props.options])

    return {
      loading,
      setLoading,
      formula,
      onChangeFormula,
      paramConfigs,
    }
  })
)

export default enhancer(DetailComponent)
